"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientTreatmentStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ClinicalEvent_1 = require("./ClinicalEvent");
var TreatmentStatus_1 = require("./TreatmentStatus");
var PatientTreatmentStatus_Factory = /** @class */ (function () {
    function PatientTreatmentStatus_Factory() {
    }
    PatientTreatmentStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ActualCompletionDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ActualCompletionDate, { ignoreTimePortion: true }),
            ClinicalEvents: model.ClinicalEvents && model.ClinicalEvents.map(function (i) { return ClinicalEvent_1.ClinicalEvent_Factory.CreateIncoming(i); }),
            EstimatedCompletionDate: Date_Factory_1.Date_Factory.CreateIncoming(model.EstimatedCompletionDate, { ignoreTimePortion: true }),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartDate: Date_Factory_1.Date_Factory.CreateIncoming(model.StartDate, { ignoreTimePortion: true }),
            TreatmentModalityCode: model.TreatmentModalityCode,
            TreatmentStatus: TreatmentStatus_1.TreatmentStatus_Factory.CreateIncoming(model.TreatmentStatus),
            TreatmentStatusId: model.TreatmentStatusId,
        };
        return result;
    };
    PatientTreatmentStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ActualCompletionDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ActualCompletionDate, { ignoreTimePortion: true }),
            ClinicalEvents: model.ClinicalEvents && model.ClinicalEvents.map(function (i) { return ClinicalEvent_1.ClinicalEvent_Factory.CreateOutgoing(i); }),
            EstimatedCompletionDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.EstimatedCompletionDate, { ignoreTimePortion: true }),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            StartDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.StartDate, { ignoreTimePortion: true }),
            TreatmentModalityCode: model.TreatmentModalityCode,
            TreatmentStatus: TreatmentStatus_1.TreatmentStatus_Factory.CreateOutgoing(model.TreatmentStatus),
            TreatmentStatusId: model.TreatmentStatusId,
        };
        return result;
    };
    return PatientTreatmentStatus_Factory;
}());
exports.PatientTreatmentStatus_Factory = PatientTreatmentStatus_Factory;
